module.exports = __webpack_public_path__ + "static/media/github-logo.bafee7d2.png";